import { dateFormat, format, getComputedDate } from './date.utils';
import {
    Operators,
    AvailableModeView,
    defBskLoadMax,
    BskColorType,
    VariableBsk,
    bsk_mailaction,
    AvailableModeViewDoc,
    tokenName,
    InfosDoc
} from '@documalis/_const/const';
import { parseDate } from '@documalis/_const/const';
import { Variable } from '@documalis/_const/const';
import { actionMail } from '@documalis/_const/const';
import { defaultPage } from '@documalis/_const/const';
import { Visibility } from '@documalis/_const/const';
import { MaxUpload } from '@documalis/_const/const';
import { ext_Pdf, ext_Tiff, ext_Images, ext_Text, ext_Calc, ext_Show, ext_Mail, ext_Ged } from '@documalis/_const/const';
import {
    doc_name,
    doc_atfcount,
    bsk_docdate,
    bsk_docstatus,
    bsk_maillimit,
    bsk_mailurgent,
    bsk_mailconf,
    bsk_delay,
} from '@documalis/_const/const';
import emojiRegex from 'emoji-regex';
import { GridsterConfig } from 'angular-gridster2/lib/gridsterConfig.interface';

export interface RequestItem {
    Criteria: {
        Name;
        FieldType;
        OperatorType;
        Value;
    };
}

export interface RequestResult {
    Criteria: {
        Name;
        FieldType;
        Sort;
        SortType;
    };
}

export interface currentRequest {
    type;
    request;
}

export interface currentSelectedBsk {
    bskLabel?;
    bskName?;
    bskType?;
    bskTypeSearch?;
    bskAllowActions?;
    bskBlockDoc?;
    bskRequiredComment?;
    bskApply?;
    bskbuttonList?;
    bskTypeDock?;
    bskUsePreProcess?;
    bskPreProcessName?;
    bskParameterList?;
    bskRights?;
    bskPdfView?;
    bskMaxShowDoc?;
    bskModeAutoLock?;
    bskUpdateAfterVal?;
    bskRestFormat?;
    bskIndexInputMode?;
    bskAtfActions?;
    bskDockDyn?;
    bskDockDynLabel?;
    bskAllowSetRvf?;
    bskAllowCreateVersion?;
    bskComposition?;
}

export interface currentBskProperty {
    bsk_docdate;
    bsk_docstatus;
    bsk_wkfid;
    bsk_mailaction;
    bsk_maillimit;
    bsk_mailurgent;
    bsk_mailconf;
}

export interface infosMail {
    dateLimit: Date;
    status;
    mailAction: number;
    mailLimit: boolean;
    mailUrgent: boolean;
    mailConf: boolean;
    mailActionLabel;
    mailDelay: number;
}

export interface atfActions {
    atfRenaming: string;
    atfAllowAddFile: boolean;
    atfAllowDelete: boolean;
    atfAllowRename: boolean;
    atfAllowPrefixList: boolean;
    atfAllowConvertPdf: boolean;
    atfAllowSaveAs: boolean;
}

export interface PreferData {
    id: number;
    datapref: string;
}

export interface ImageItem {
    url: string;
    page: string;
    action: string;
    rotate: number;
    numPageOrig: string
}

// export const deepCopy = <T>(target: T): T => {
//     if (target === null) {
//         return target;
//     }
//     if (target instanceof Date) {
//         return new Date(target.getTime()) as any;
//     }
//     if (target instanceof Array) {
//         const cp = [] as any[];
//         (target as any[]).forEach((v) => {
//             cp.push(v);
//         });
//         return cp.map((n: any) => deepCopy<any>(n)) as any;
//     }
//     if (typeof target === 'object' && target !== {}) {
//         const cp = { ...(target as { [key: string]: any }) } as { [key: string]: any };
//         Object.keys(cp).forEach((k) => {
//             cp[k] = deepCopy<any>(cp[k]);
//         });
//         return cp as T;
//     }
//     return target;
// };


export function getGridsterOptions(ignoreContent, dragHandleClass, displayGrid): GridsterConfig {
    return {
        margin: 5,
        outerMargin: true,
        outerMarginTop: null,
        outerMarginRight: null,
        outerMarginBottom: null,
        outerMarginLeft: null,
        useTransformPositioning: true,
        mobileBreakpoint: 640,
        useBodyForBreakpoint: true,
        minCols: 32,
        maxCols: 32,
        minRows: 15,
        maxItemCols: 32,
        minItemCols: 5,
        maxItemRows: 100,
        minItemRows: 3,
        maxItemArea: 500,
        minItemArea: 1,
        defaultItemCols: 1,
        defaultItemRows: 1,
        fixedColWidth: 105,
        fixedRowHeight: 90,
        keepFixedHeightInMobile: false,
        keepFixedWidthInMobile: false,
        scrollSensitivity: 10,
        scrollSpeed: 20,
        enableEmptyCellClick: false,
        enableEmptyCellContextMenu: false,
        enableEmptyCellDrop: false,
        enableEmptyCellDrag: false,
        enableOccupiedCellDrop: false,
        emptyCellDragMaxCols: 50,
        emptyCellDragMaxRows: 50,
        ignoreMarginInRow: false,
        draggable: {
            ignoreContent: ignoreContent,
            dragHandleClass: dragHandleClass,
            enabled: false
        },
        resizable: {
            enabled: false
        },
        swap: true,
        pushItems: true,
        disablePushOnDrag: false,
        disablePushOnResize: false,
        pushDirections: {north: true, east: false, south: true, west: false},
        pushResizeItems: false,
        disableWindowResize: false,
        disableWarnings: false,
        scrollToNewItems: false,
        displayGrid: displayGrid,
        compactType: "compactUp",
        gridType: 'verticalFixed'
    };
}

export function getParseToken() {
    return JSON.parse(getStorageToken());
}

export function getStorageToken() {
    return localStorage.getItem(tokenName);
}

export function storeData(aName, aData) {
    localStorage.setItem(aName, aData);
}

export function clearStorage() {
    localStorage.clear();
    indexedDB.deleteDatabase('Documalis');
}

export function getColorName(aName) {
    let wColor;
    wColor = aName.replaceAll(' ', '_');
    wColor = wColor.replaceAll('.', '_');
    return wColor;
}

export function get_bskLabel(item, aName) {
    let wLabel = '';
    if (Array.isArray(item.Information.Label)) {
        wLabel = formatLabel(aName, '_');
    } else {
        wLabel = decodeUtf8(item.Information.Label);
    }
    return wLabel;
}


export function formatLabel(label, char, newChar = ' ') {
    let wRes = label;
    wRes = wRes.replace(new RegExp(char, 'g'), newChar);
    wRes = wRes.replace(/([a-z])([A-Z])/g, '$1 $2');
    if (wRes.length > 35) {
        wRes = wRes.substring(0, 35);
    }
    return wRes;
}

export function prepareInfosDoc(aData, aVariableName) {
    let wFind: any;
    let warray = [];
    for (let property in aData) {
        if (aData.hasOwnProperty(property)) {
            wFind = InfosDoc.find((infos) => {
                return infos.id === property;
            });
            if (wFind) {
                warray.push(formatInfosData(wFind, aData, property, aVariableName));
            }
        }
    }
    return warray;
}

export function formatInfosData(aFind, aData, aProperty, aVariableName) {
    let wValue = '';
    let wLabel = '';
    let wInfo: any;
    wLabel = aProperty;
    wInfo = Variable.find((variable) => {
        return variable.Name === aFind.Name;
    });
    if (wInfo) {
        wValue = formatInfosDataValue(wInfo, aData, aProperty);
        wLabel = aVariableName[wInfo.Name].Label;
    } else {
        wValue = decodeUtf8(aData[aProperty]);
    }
    return {
        name: aProperty,
        value: wValue,
        Label: wLabel,
    };
}

export function formatInfosDataValue(aInfo, aData, aProperty) {
    let wValue = '';
    if (aInfo.Type === 'DateTime') {
        wValue = dateFormat(aData[aProperty], 'dd/MM/yyyy HH:mm:ss');
        if (wValue === '30/12/1899 12:00:00') {
            wValue = '';
        }
    } else {
        if (aInfo.Name === '&doc_size') {
            wValue = fileConvertSize(aData[aProperty]);
        } else {
            wValue = decodeUtf8(aData[aProperty]);
        }
    }
    return wValue;
}

export function loadVariableName(aTranslate) {
    let VariableName = {};
    Variable.forEach((item) => {
        VariableName[item.Name] = {
            Label: aTranslate.instant(item.Name),
        };
    
    })
    return VariableName;
}

export function getInternalPrefUsr() {
    let wInternalPrefUsr: any = {};
    wInternalPrefUsr = JSON.parse(atob(localStorage.getItem('internalprefusr')));
    wInternalPrefUsr.bskNextVal = returnDef(wInternalPrefUsr.bskNextVal, false);
    wInternalPrefUsr.emptyBsk = returnDef(wInternalPrefUsr.emptyBsk, false);
    wInternalPrefUsr.gradBsk = returnDef(wInternalPrefUsr.gradBsk, true);
    wInternalPrefUsr.bskLoadMax = returnDef(wInternalPrefUsr.bskLoadMax, defBskLoadMax);
    wInternalPrefUsr.modeView = returnDef(wInternalPrefUsr.modeView, AvailableModeView[0].value);
    wInternalPrefUsr.modeViewDoc = returnDef(wInternalPrefUsr.modeViewDoc, AvailableModeViewDoc[0].value);
    wInternalPrefUsr.defaultFullTextDate = returnDef(wInternalPrefUsr.defaultFullTextDate, 'TNoDate');
    wInternalPrefUsr.defaultPage = returnDef(wInternalPrefUsr.defaultPage, defaultPage);
    wInternalPrefUsr.bskCompact = returnDef(wInternalPrefUsr.bskCompact, false);
    wInternalPrefUsr.displayConfirm = returnDef(wInternalPrefUsr.displayConfirm, true);
    wInternalPrefUsr.requestOrder = returnDef(wInternalPrefUsr.requestOrder, false);
    return wInternalPrefUsr;
}

export function returnDef(value, aDefault) {
    return value === undefined || value === null ? aDefault : value;
}

export function generateUUID() {
    // Public Domain/MIT
    var d = new Date().getTime();
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
        d += performance.now(); //use high-precision timer if available
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
}

export function getPref(aData, aId, aDefault) {
    let wRes = null;
    for (let item of aData.data) {
        if (item.typepref === aId) {
            wRes = item;
            break;
        }
    }
    if (wRes === null) {
        wRes = {
            id: 0,
            datapref: aDefault,
        };
    }
    return wRes;
}

export function replEmoji(text: string, aMessageService, aTranslate) {
    let wText = text;
    if (emojiRegex().test(wText)) {
        wText = wText.replace(emojiRegex(), '');
        aMessageService.addWarnNoStick(aTranslate.instant('NoEmoji'));
    }
    return wText;
}

export function getProperty(aData, aName) {
    const normalizedName = aName.toUpperCase();
    const wRes = aData.find((item) => {
        if (item.name !== undefined) {
            return item.name.toUpperCase() === normalizedName;
        } else {
            return item.Name.toUpperCase() === normalizedName;
        }
    });
    if (wRes) {
        return wRes.value;
    }
}

export function setCurrentRequest(aType, aRequest) {
    return {
        type: aType,
        request: aRequest,
    };
}

export function setUpdatePref(aId, aTypePref, aValue) {
    let wRequestData: {};
    wRequestData = {
        id: aId,
        typepref: aTypePref,
        datapref: aValue,
    };
    return wRequestData;
}

export function hasVariable(abskVariableList) {
    let wHasVariable = false;
    for (const item of abskVariableList) {
        if (item.system === 'false' || item.visible === 1 || item.isActiv === 'true') {
            wHasVariable = true;
            break;
        }
    }
    return wHasVariable;
}

export function setResultList(absk) {
    let wResultList = new Array();
    wResultList = [];
    if (absk.bskRights.TDAft === true) {
        wResultList.push(doc_atfcount);
    }
    wResultList.push(bsk_docdate);
    wResultList.push(doc_name);
    wResultList.push(bsk_docstatus);
    setResulProperty(wResultList, doc_name.name, 'thumbinfo', 1);
    setResulProperty(wResultList, bsk_docdate.name, 'typeorder', getSortType(absk));

    if (absk.bskType === 'btMail') {
        wResultList.push(bsk_maillimit);
        wResultList.push(bsk_mailurgent);
        wResultList.push(bsk_mailconf);
        wResultList.push(bsk_delay);
        wResultList.push(bsk_mailaction);
    }
    return wResultList;
}

export function setResult(aList, aIndex, aTranslate) {
    aList.push({
        name: aIndex.name,
        type: aIndex.type,
        label: aTranslate.instant(aIndex.name),
        sort: -1,
        typeorder: 0,
        thumbinfo: aIndex.thumbinfo,
    });
}

export function getSortType(absk) {
    if (absk.bskOrder === 'DateDes') {
        return 1;
    } else {
        return 0;
    }
}

export function formatCriteria(aEditorService, aVariableList, aEmptyField) {
    let wRequest = new Array();
    for (let i = 0; i < aVariableList.length; i++) {
        let wRequestItem: RequestItem;
        let wValue = '';
        if (aVariableList[i].value !== undefined) {
            wValue = aEditorService.getValueFromType(aVariableList[i], true);
            aVariableList[i].DefaultValue = aEditorService.getValueFromType(aVariableList[i], false);
        }
        if (wValue !== '' || aEmptyField === false) {
            if (typeof wValue === 'string') {
                wValue = encodeUtf8(wValue);
            }
            wRequestItem = setCriteriaItem(aVariableList[i], aVariableList[i].operator, wValue);
            wRequest.push(wRequestItem);
        }
    }
    return wRequest;
}

export function setCriteriaItem(aVariable, aOperator, aValue) {
    let wRequestItem: RequestItem;
    wRequestItem = {
        Criteria: {
            Name: aVariable.name,
            FieldType: aVariable.type,
            OperatorType: aOperator,
            Value: aValue,
        },
    };
    return wRequestItem;
}

export function formatResult(aResultList) {
    let wResult = new Array();
    for (let i = 0; i < aResultList.length; i++) {
        let wRequestItem: RequestResult;
        wRequestItem = {
            Criteria: {
                Name: aResultList[i].name,
                FieldType: aResultList[i].type,
                Sort: aResultList[i].sort,
                SortType: aResultList[i].typeorder,
            },
        };
        wResult.push(wRequestItem);
    }
    return wResult;
}

export function setInfosMail(aReset, aData, aTranslate) {
    let wActionMail: any;
    if (aReset === true) {
        wActionMail = getActionMail(0);
        return {
            dateLimit: new Date(),
            status: '',
            mailAction: 0,
            mailLimit: false,
            mailUrgent: false,
            mailConf: false,
            mailActionLabel: aTranslate.instant('Mail_'+ '0'),
            mailDelay: 0,
        };
    }
    wActionMail = getActionMail(Number(aData.bsk_mailaction));
    let wMmailLimit = false;
    let wDateLimit;
    if (aData.bsk_maillimit === '' || aData.bsk_maillimit === '|') {
        wDateLimit = new Date();
    } else {
        wMmailLimit = true;
        wDateLimit = new Date(getDateInternal(aData.bsk_maillimit));
    }

    return {
        dateLimit: wDateLimit,
        status: aData.bsk_docstatus,
        mailAction: wActionMail.value,
        mailLimit: wMmailLimit,
        mailUrgent: !(aData.bsk_mailurgent === '0'),
        mailConf: !(aData.bsk_mailconf === '0'),
        mailActionLabel: aTranslate.instant('Mail_'+ wActionMail.value),
        mailDelay: aData.bsk_delay,
    };
}

export function getActionMail(aMailAction) {
    return actionMail.find((item) => {
        return item.value === aMailAction;
    });
}

export function getDelay(aMmailLimit, aDelay) {
    let wRes = 0;
    let wNbDays = 0;
    if (aMmailLimit === '') {
        return wRes;
    }
    if (Array.isArray(aMmailLimit)) {
        return wRes;
    }
    const wDateB = new Date(aMmailLimit);
    const wDateE = new Date();
    wNbDays = Math.trunc(wDateB.getTime() / 86400000 - wDateE.getTime() / 86400000);
    if (wNbDays <= aDelay.Delay4) {
        wRes = 4; // red
    } else {
        if (wNbDays > aDelay.Delay4 && wNbDays <= aDelay.Delay3) {
            wRes = 3; // orange
        } else {
            if (wNbDays > aDelay.Delay3 && wNbDays <= aDelay.Delay2) {
                wRes = 2; // green
            } else {
                if (wNbDays > aDelay.Delay2 && wNbDays <= aDelay.Delay1) {
                    wRes = 1; // grey
                }
            }
        }
    }
    return wRes;
}

export function verifyParamsRequest(aLabelRequest, aCurrentLabel, aCurrentId, aRequests, aMessageService, aTranslate) {
    if (aLabelRequest.trim() === '') {
        aMessageService.addErrorNoStick(aTranslate.instant('Query_1_Req'));
        return false;
    }
    if (aCurrentId === 0 && findItem(aRequests, aLabelRequest, 'label') !== -1) {
        aMessageService.addErrorNoStick(aTranslate.instant('Query_2_Req'));
        return false;
    }
    if (aLabelRequest !== aCurrentLabel) {
        if (findItem(aRequests, aLabelRequest, 'label') !== -1) {
            aMessageService.addErrorNoStick(aTranslate.instant('Query_2_Req'));
            return false;
        }
    }
    return true;
}

export function findItem(aList, aValue, aProp) {
    let wIndex = -1;
    wIndex = aList.findIndex((item) => {
        return item[aProp] === aValue;
    });
    return wIndex;
}

export function deleteList(aList, aId) {
    let wIndex = -1;
    wIndex = findItem(aList, parseInt(aId), 'id');
    if (wIndex !== -1) {
        aList.splice(wIndex, 1);
    }
    return aList;
}

export function getDateInternal(aDate) {
    let wIndex = -1;
    wIndex = aDate.indexOf('|');
    if (wIndex !== -1) {
        return aDate.substring(0, wIndex);
    } else {
        return '';
    }
}

export function verifyDataEnter(aVarList, aEditorService, aMessageService, aTranslate) {
    if (verifyPattern(aVarList, aEditorService, aMessageService, aTranslate) === false) {
        return false;
    }
    if (verifyRequiredIndex(aVarList, aEditorService, aMessageService, aTranslate) === false) {
        return false;
    }
    return true;
}

export function verifyPattern(aVarList, aEditorService, aMessageService, aTranslate) {
    let wMess = '';
    wMess = aEditorService.verifyPattern(aVarList);
    if (wMess !== '') {
        aMessageService.addErrorNoStick(aTranslate.instant('Ent_NotValid') + '\n' + wMess);
        return false;
    }
    return true;
}

export function verifyRequiredIndex(aVarList, aEditorService, aMessageService, aTranslate) {
    let wMess = '';
    wMess = aEditorService.verifyRequiredIndex(aVarList);
    if (wMess !== '') {
        aMessageService.addErrorNoStick(aTranslate.instant('Miss_IdxReq') + '\n' + wMess);
        return false;
    }
    return true;
}

export function verifySizeDownLoad(aUploader, aMessageService, aTranslate) {
    if (aUploader.queue.length === 0) {
        return false;
    }
    let wCount = 0;
    let wMaxSize = MaxUpload;
    let wDiv = 1000000;
    let wUnit = 'Mo';
    let wInternal = JSON.parse(atob(localStorage.getItem('intern')));
    let wMax = wInternal.maxload;
    wMaxSize = Number(wMax);
    if (wMaxSize >= 1000000000) {
        wDiv = 1000000000;
        wUnit = 'Go';
    }
    aUploader.queue.forEach((item) => {
        if (verifyFileSize(item.file.size, wMaxSize) === false) {
            aUploader.removeFromQueue(item);
            aMessageService.addErrorNoStick(aTranslate.instant('Ctrl_File', {file: item.file.name , width: (wMaxSize / wDiv), unit: wUnit}));
            wCount++;
        }
    });
    return wCount === 0;
}

export function verifyExtension(aUploader, aMessageService, aCurrentSelectedBsk, aTranslate) {
    if (aUploader.queue.length === 0) {
        return false;
    }
    let wListExt = getAllowExtAll(aCurrentSelectedBsk);
    let wCount = 0;
    aUploader.queue.forEach((item) => {
        if (wListExt.indexOf(getFileExt(item.file.name).toLowerCase()) === -1) {
            aUploader.removeFromQueue(item);
            aMessageService.addErrorNoStick(aTranslate.instant('Ctrl_FileExt', {file: item.file.name}));            
            wCount++;
        }
    });
    return wCount === 0;
}

export function verifyExistFile(aUploader, aData, aCtrlDouble) {
    let wChange = false;
    if (aUploader.queue.length === 0) {        
        return aCtrlDouble;
    }
    for (let i = aUploader.queue.length -1; i >=0; i--) {
        if ( aUploader.queue[i].file.name.toLowerCase() === aData.file.name.toLowerCase() && i !== aUploader.queue.length -1 ) {
            wChange = true;
            break;
        }
    }
    for (let i = aUploader.queue.length -1; i >=0; i--) {
        if ( aUploader.queue[i].file.name.toLowerCase() === aData.file.name.toLowerCase()) {
            aUploader.removeFromQueue(aUploader.queue[i]);
        }
    }
    aUploader.queue.push(aData);

    if (wChange === true) {
        aCtrlDouble = aCtrlDouble.filter((item) => {
            return item.name.toLowerCase() !== aData.file.name.toLowerCase()
        })
    }
    aCtrlDouble.push({
        name: aData.file.name,
        change: wChange
    });
    return aCtrlDouble;
}

export function getAllowExtAll(aCurrentSelectedBsk) {
    let wListExt = new Array();
    wListExt = [];
    if (aCurrentSelectedBsk !== null) {
        wListExt = getBskAllowExt(aCurrentSelectedBsk);
    }
    if (wListExt.length === 0) {
        wListExt = [];
        wListExt = getAllowExt();
    }
    return wListExt;
}

export function verifyFileSize(aSize, aMaxSize) {
    if (aSize >= aMaxSize) {
        return false;
    } else {
        return true;
    }
}

export function prepareExportExcel(aListColumns, aListDocs) {
    let wListRes = [];
    let wItem = [];
    let wIndex = 0;
    let wDate = '';
    aListDocs.forEach((item) => {
        wItem = [];
        aListColumns.forEach((col) => {
            if (col.type === 'DateTime') {
                wDate = '';
                wIndex = item[col.field].indexOf('|');
                if (wIndex !== -1) {
                    wDate = item[col.field].substring(wIndex + 1);
                }
                wItem[col.header] = wDate;
            } else {
                wItem[col.header] = item[col.field];
            }
        });
        const jsonString = Object.assign({}, wItem);
        wListRes.push(jsonString);        
    });
    return wListRes;
}

export function prepareValue(aItem) {
    aItem.webReqDetails.map((element) => {
        if (element.valdefault) {
            element.value = element.valdefault;
            element.DefaultValue = element.valdefault;
        } else {
            element.DefaultValue = '';
        }
        if (element.type === 'Date' || element.type === 'DateTime') {
            element.value = format(getComputedDate(element.value));
            element.DefaultValue = element.value;
            element.valdefault = element.value;
        }
        element.Label = element.label;
        element.Editable = false;
        element.pattern = '';
        element.disabled = false;
        delete element['label'];
        return element;
    });
}

export function prepareResultValue(aItem) {
    aItem.webResultDetails.map((element) => {
        element.Label = element.label;
        delete element['label'];
        return element;
    });    
}

export function formatVariableTransfert(aRes) {
    let wVariableListTransfert = [];
    wVariableListTransfert = aRes.VariableList.Variable;
    wVariableListTransfert.map((item: any) => {
        item.label = item.Label;
        item.Editable = getEditable(item);
        item.hidden = item.Hidden;
        item.name = item.Name;
        item.value = returnEmpty(item.Value);
        item.type = item.Type;
    });
    return wVariableListTransfert;
}

export function formatRequestCount(aNbDocs) {
    let wRequest = { RequestCount: aNbDocs };
    return wRequest;
}


export function formatFormDataRequest(aRequest) {
    let wjson = '';
    wjson = JSON.stringify(aRequest);
    let wFormData = new FormData();
    wFormData.append('Request', wjson);
    return wFormData;
}

export function formatRequestExport(aSelected, aFormat) {
    let wListId = '';
    let wAction;
    aSelected.forEach((item) => {
        wListId = wListId + item.doc_docid + ',';
    });

    const type = {
        optpdf: '0',
        optzip: '1',
        optori: '2',
        optzdoc: '3',
    }
    if (type[aFormat]) {
        wAction = Number(type[aFormat]);
    }
    let wRequest = {        
        Docid: wListId,
        ActionDataMatrix: 'NoDataMx',
        Action: wAction,
        Batch: true,
        BatchType: getBatchType(wAction),
        Stat: getBatchName(wAction),
    };
    return wRequest;
}

export function getInternalAction(aAction) {
    let wAction: string;
    switch (aAction) {
        case 'mailcopy': {
            wAction = 'copy';
            break;
        }
        case 'mailmove': {
            wAction = 'move';
            break;
        }
        case 'duplicate':            
        case 'mailduplicate': {
            wAction = 'clone';
            break;
        }  
        default: {
            wAction = aAction;
            break;
        }
    }
    return wAction;
}

export function getBatchType(aValue) {
    switch (aValue) {
        case 'stat': return 0;  // statistique, ext xlsx
        case 0 : return 1;    // concat pdf, ext pdf
        case 1: return 2;     // zip copy, ext zip
        case 2: return 3;     // zip origin, ext zip
        case 3: return 4;     // zdoc, ext zip
    }
}

export function getBatchName(aValue) {
    switch (aValue) {
        case 0 : return 'PdfConcat';    // concat pdf, ext pdf
        case 1: return 'ZipCopy';     // zip copy, ext zip
        case 2: return 'ZipOri';     // zip origin, ext zip
        case 3: return 'ZipZdoc';     // zdoc, ext zip
    }
}


export function formatRequestMail(aData, aSelectedDocs) {
    let wZip = 'false';
    let wAddAtf = 'false';
    let wDocList = {};
    let wRequest = {};
    wDocList = formatListDoc(aSelectedDocs);
    if (aData.mailZip !== null) {
        if (aData.mailZip) {
            wZip = 'true';
        }
    }
    if (aData.mailAddAtf !== null) {
        if (aData.mailAddAtf) {
            wAddAtf = 'true';
        }
    }
    wRequest = {
        MailTo: encodeUtf8(returnEmpty(aData.mailTo)),
        MailCc: encodeUtf8(returnEmpty(aData.mailCc)),
        MailCci: encodeUtf8(returnEmpty(aData.mailCci)),
        MailSubject: encodeUtf8(returnEmpty(aData.mailSubject)),
        MailMsg: encodeUtf8(returnEmpty(aData.mailMsg)),
        MailZip: wZip,
        MailAddAtf: wAddAtf,
        DocList: wDocList,
    };
    return wRequest;
}

export function formatListDoc(aSelectedDocs) {
    let wResult = new Array();
    let wItem: {};
    aSelectedDocs.forEach((item) => {
        wItem = {
            DocInfo: {
                Id: item.doc_docid,
                Root: item.doc_root,
                Path: encodeUtf8(item.doc_path),
                Name: encodeUtf8(item.doc_name),
            },
        };
        wResult.push(wItem);
    });
    return wResult;
}

export function formatRequestStat(aStat, wStatId, aRequest, aStatExt) {
    let wRequest = {
        Stat: aStat,
        StatId: wStatId,
        StatExt: aStatExt,
        RequestType: aRequest.type,
        RequestExec: aRequest.request,
        Batch: true,
        BatchType: getBatchType('stat'),
    };
    return wRequest;
}

export function getlistColumns(adata, aTranslate) {
    let name;
    let wItem: any;
    let wColList = new Array();
    for (let i = 0; i < adata.length; i++) {
        name = adata[i].name.replace('&', '');
        if (name === 'bsk_mailaction') {
            wItem = { header: aTranslate.instant(adata[i].name), field: 'bsk_mailactionLabel', type: 'String' };
        } else {
            if (adata[i].name.substring(0,1) !== '&') {
                wItem = { header: adata[i].label, field: name, type: adata[i].type };
            } else {
                wItem = { header: aTranslate.instant(adata[i].name), field: name, type: adata[i].type };
            }
        }
        wColList.push(wItem);
    }
    return wColList;
}

export function setinfoList(aResultList) {
    let wInfoList = new Array();
    aResultList.map((item) => {
        if (item.thumbinfo === 1) {
            wInfoList.push(item);
        }
    });
    return wInfoList;
}

export function concatAllBasket(...basketLists) {
    let warray = [];
    basketLists.forEach(basketList => {
        setArrayAllBasket(warray, basketList);
    });
    return warray;
}

export function setArrayAllBasket(aArray, aList) {
    if (aList !== null) {
        if (aList.length !== 0) {
            aList.forEach((item) => {
                aArray.push(item);
            });
        }
    }
}

export function formatDataSensBsk(aList, aKey) {
    let wReqBskList = [];
    let wBasketList = [];
    let wIdreq = '';
    let wData: any = {};

    for (let i = 0; i < aList.length; i++) {
        if (wIdreq === '') {
            wIdreq = aList[i][aKey];
            setData(wData, aList[i].label, aList[i].id, aList[i].reference);
        }
        if (wIdreq !== aList[i][aKey]) {
            insertData(wReqBskList, wData, wBasketList);
            wIdreq = aList[i][aKey];
            setData(wData, aList[i].label, aList[i].id, aList[i].reference);
            wBasketList = [];
        }
        wBasketList.push({
            name: aList[i].bskname,
            label: aList[i].bsklabel,
        });
    }
    if (wIdreq !== '') {
        insertData(wReqBskList, wData, wBasketList);
    }
    return wReqBskList;
}


export function formatDataBskSens(aList, aKey) {
    let wReqBskList = [];
    let wBasketList = [];
    let wBskName = '';
    let wData: any = {};

    for (let i = 0; i < aList.length; i++) {
        if (wBskName === '') {
            wBskName = aList[i].bskname;
            setData(wData, aList[i].bsklabel, aList[i].id, aList[i][aKey]);
        }
        if (wBskName !== aList[i].bskname) {
            insertData(wReqBskList, wData, wBasketList);
            wBskName = aList[i].bskname;
            setData(wData, aList[i].bsklabel, aList[i].id, aList[i][aKey]);
            wBasketList = [];
        }
        wBasketList.push({
            name: aList[i].label,
            label: aList[i].label,
            id: aList[i].id,
            reference: aList[i][aKey],
        });
    }
    if (wBskName !== '') {
        insertData(wReqBskList, wData, wBasketList);
    }
    return wReqBskList;
}

export function insertData(aReqBskList, aData, aBasketList) {
    aReqBskList.push(
        {
            label: aData.label,
            id: aData.id,
            reference: aData.reference,
            baskets: aBasketList,
            name: aData.label,
            _label: aData.label
        }
    )
}

export function setData(aData, aLabel, aId, aReference) {
    aData.label = aLabel;
    aData.id = aId;
    aData.reference = aReference;  
}

export function getBasketList(aList) {
    let warray = new Array();
    for (let i = 0; i < aList.length; i++) {
        warray.push({
            name: aList[i].Information.Name,
            label: aList[i].Information.Label
        });
    }
    return warray;
}

export function getBasketLabel(aList, aName, aKey) {
    let wName: any;
    wName = aList.find(item => item[aKey] === aName);
    if (wName === undefined) {
        return aName;
    } else {
        return wName.label;
    }
}

export function setFormatList(aData) {
    let wList = [];
    let wFormatList = [];
    if (aData.length !== 0) {
        wList = aData.split(',');
        wList.forEach((item) => {
            wFormatList.push({label: item, value: item});
        });
    }
    return wFormatList;
}

export function formatRequestBasket(
    aEditorService,
    aVariableList,
    aResultList,
    aCount,
    wBskName,
    wBskType,
    aUseLock,
    aMaxResult,
    aEmptyField,
    aSearchWord,
) {
    let wCriteria = formatCriteria(aEditorService, aVariableList, aEmptyField);
    let wResult = formatResult(aResultList);
    let wRequest = {        
        CountDoc: aCount,
        BskName: wBskName,
        BskType: wBskType,
        UseLock: aUseLock,
        MaxResult: aMaxResult,
        Search: { CriteriaList: wCriteria, ResultList: wResult },
        SearchWord: encodeUtf8(aSearchWord),
    };
    return wRequest;
}

export function formatRequestUnlock(aDocIdList) {
    let wRequest = {
        Docid: aDocIdList,
    };
    return wRequest;
}

export function formatRequestIndex(aEditorService, aVariableList, aResultList, aCount, 
    aRequestId, aResultId, aEmptyField, aSearchWord, aOffSet, aFetch) {
    let wCriteria = formatCriteria(aEditorService, aVariableList, aEmptyField);
    let wResult = formatResult(aResultList);
    let wRequest = {
        CountDoc: aCount,
        Search: { CriteriaList: wCriteria, ResultList: wResult },
        requestid: aRequestId,
        resultid: aResultId,
        EmptyField: aEmptyField,
        SearchWord: encodeUtf8(aSearchWord),
        OffSet: aOffSet,
        Fetch: aFetch
    };
    return wRequest;
}

export function getDocIndex(aTranslate) {
    Variable.forEach(item => {
        item.Label = aTranslate.instant(item.Name);
    });  
    return Variable;
}

export function getBskIndex(aTranslate) {
    VariableBsk.forEach(item => {
        item.Label = aTranslate.instant(item.Name);
    });
    return VariableBsk;
}

export function getEmptyField(aEmptyfield) {
    if (aEmptyfield === null) {
        return true;
    } else {
        return aEmptyfield === 0 ? false : true;
    }
}

export function getOperator(aid) {
    if (aid === undefined) {
        return Operators[0].type;
    } else {
        return Operators[aid].type;
    }
}

export function getPageFromType(aType) {
    let wPage = defaultPage;
    const type = {
        Wds: 'fulltextsearch',
        Variable: 'page-request-list',
        Browse: 'page-tree-search',        
        Basket: 'page-basket-list',
    }
    if (type[aType]) {
        wPage = type[aType];
    }
    return wPage;
}

export function formatVariable(aVariable) {
    aVariable.DefaultValue = getArrayField(aVariable.DefaultValue);
    aVariable.Label = getField(aVariable.Label);
    aVariable.Label = updateLabel(aVariable);
    return aVariable;
}

export function formatCustomEditor(item) {
    let wVal = [];
    if (item.DynamicIndex && !Array.isArray(item.DynamicIndex)) {
        if (Array.isArray(item.DynamicIndex.ValueList.Value)) {
            item.DynamicIndex.ValueList.Value.map((elem) => {
                elem.Name = getField(elem.Name);
                return elem;
            });
        } else {
            wVal.push({
                Name:getField(item.DynamicIndex.ValueList.Value.Name),
                GroupVariableList:getField(item.DynamicIndex.ValueList.Value.GroupVariableList)
            });
            item.DynamicIndex.ValueList.Value = wVal;
        }
    }
}

export function getField(aValue) {
    if (Array.isArray(aValue)) {
        return '';
    } else {
        return decodeUtf8(aValue);
    }
}

export function updateLabel(aVariable) {
    if (aVariable.Label === '') {
        aVariable.Label = aVariable.Name;
    }
    return aVariable.Label;
}

export function getArrayField(aValue) {
    if (Array.isArray(aValue)) {
        return '';
    } else {
        return aValue;
    }
}

export function setCustomBskColorList(aIntern, aBskList) {
    let wColorList = [];
    let wColor: any;
    wColor = JSON.parse(localStorage.getItem('bskcolorlist'));
    wColor.forEach((item) => {
        wColorList[item.id] = item.color;
    })

    setBasketColor(aBskList.BasketCollectList.BasketCollect,wColorList,aIntern.bskCollectColor);    
    setBasketColor(aBskList.BasketMailList.BasketMail,wColorList,aIntern.bskMailColor);
    setBasketColor(aBskList.BasketPublishList.BasketPublish,wColorList,aIntern.bskPublishColor);    
    setBasketColor(aBskList.BasketActionList.BasketAction,wColorList,aIntern.bskActionColor);    
    setBasketColor(aBskList.BasketInputList.BasketInput,wColorList,aIntern.bskInputColor);    
    setBasketColor(aBskList.BasketOutputList.BasketOutput,wColorList,aIntern.bskOutputColor);    
    setBasketColor(aBskList.BasketSystemList.BasketSystem,wColorList,aIntern.bskSystemColor);    
}

export function setBasketColor(aBskList, aBskColorList, aDefColor) {
    let wColorName;
    aBskList.map((item) => {
        wColorName = item.Information.Name;
        item.Information.color = getColorName(item.Information.Name);
        if (aBskColorList[wColorName] !== undefined) {
            addBasketColor(item.Information.color, aBskColorList[wColorName]);
        } else {
            addBasketColor(item.Information.color, aDefColor);
        }
    })
}

export function addBasketColor(aName, aBckColor) {
    addClassName(aName, aBckColor);
}

export function addClassName(aName, aBckColor) {
    const style = document.createElement('style');

    style.setAttribute("id", aName);

    var wColor = '.class' + aName + '{ background-color: ' + aBckColor + '!important;}';
    style.innerHTML = wColor;

    let el = document.getElementById(aName);
    if (el === null) {
        document.head.appendChild(style);
    } else {
        document.head.replaceChild(style, el);
    }
}

export function setBskColor(aColorList) {
    BskColorType.map(item => {
        setOneColor(item, aColorList[item]);
    })
}

export function setOneColor(aItem, aColor) {
    document.documentElement.style.setProperty('--' + aItem + '-primary', aColor);
    let darken = colorLuminance(aColor, -50);
    document.documentElement.style.setProperty('--' + aItem + '-secondary', darken);    
}

export function updateCssDefault(aIntern) {
    interface ColorScheme {
        primary: string;
        secondary: string;
    }
    const colorSchemes: { [key: string]: ColorScheme } = {
        bskCollectColor: { primary: aIntern.bskCollectColor, secondary: aIntern.bskCollectColor },
        bskMailColor: { primary: aIntern.bskMailColor, secondary: aIntern.bskMailColor },
        bskPublishColor: { primary: aIntern.bskPublishColor, secondary: aIntern.bskPublishColor },
        bskActionColor: { primary: aIntern.bskActionColor, secondary: aIntern.bskActionColor },
        bskInputColor: { primary: aIntern.bskInputColor, secondary: aIntern.bskInputColor },
        bskOutputColor: { primary: aIntern.bskOutputColor, secondary: aIntern.bskOutputColor },
        bskSystemColor: { primary: aIntern.bskSystemColor, secondary: aIntern.bskSystemColor },
    };
    const root = document.documentElement;
    for (const [key, value] of Object.entries(colorSchemes)) {
        root.style.setProperty(`--${key}-primary`, value.primary);
        root.style.setProperty(`--${key}-secondary`, value.secondary);
    }
}

export function colorLuminance(col,amt) {
    var usePound = false;
    if ( col[0] == "#" ) {
        col = col.slice(1);
        usePound = true;
    }

    var num = parseInt(col,16);

    var r = (num >> 16) + amt;

    if ( r > 255 ) r = 255;
    else if  (r < 0) r = 0;

    var b = ((num >> 8) & 0x00FF) + amt;

    if ( b > 255 ) b = 255;
    else if  (b < 0) b = 0;

    var g = (num & 0x0000FF) + amt;

    if ( g > 255 ) g = 255;
    else if  ( g < 0 ) g = 0;

    return (usePound?"#":"") + (g | (b << 8) | (r << 16)).toString(16);
}

export function allowConvert(aExt, aListExt) {
    if (aListExt.indexOf(aExt) !== -1) {
        return true;
    } else {
        return false;
    }
}

export function getBskAllowExt(aCurrentSelectedBsk) {
    let wListExt = new Array();
    wListExt = [];
    if (aCurrentSelectedBsk.bskRestFormat.pdf) {
        wListExt.push(...ext_Pdf);
    }
    if (aCurrentSelectedBsk.bskRestFormat.tiff) {
        wListExt.push(...ext_Tiff);
    }
    if (aCurrentSelectedBsk.bskRestFormat.picture) {
        wListExt.push(...ext_Images);
    }
    if (aCurrentSelectedBsk.bskRestFormat.text) {
        wListExt.push(...ext_Text);
    }
    if (aCurrentSelectedBsk.bskRestFormat.spreadSheet) {
        wListExt.push(...ext_Calc);
    }
    if (aCurrentSelectedBsk.bskRestFormat.presentation) {
        wListExt.push(...ext_Show);
    }
    if (aCurrentSelectedBsk.bskRestFormat.email) {
        wListExt.push(...ext_Mail);
    }
    return wListExt;
}

export function getAllowExt() {
    let wListExt = new Array();
    wListExt = [];
    wListExt.push(...ext_Pdf);
    wListExt.push(...ext_Tiff);
    wListExt.push(...ext_Images);
    wListExt.push(...ext_Text);
    wListExt.push(...ext_Calc);
    wListExt.push(...ext_Show);
    wListExt.push(...ext_Mail);
    wListExt.push(...getExtAdmin());
    wListExt.push(...ext_Ged);
    return wListExt;
}

export function getExtAdmin() {
    try {
        const encodedData = localStorage.getItem('internalprefusr');
        if (!encodedData) return [];

        const decodedData = atob(encodedData);
        const prefusr = JSON.parse(decodedData);

        return prefusr.extension ? JSON.parse(prefusr.extension) : [];
    } catch (error) {
        console.error('Error parsing extension data:', error);
        return [];
    }
}

export function isEmptyArray(aArray) {
    let wRes = false;
    if (Array.isArray(aArray)) {
        if (aArray.length === 0) {
            wRes = true;
        }
    }
    return wRes;
}

export function getBoolean(aValue) {
    if (typeof aValue === 'number') {
        if (aValue <= 1) {
            return Boolean(Number(aValue))
        }
    } else {
        return checkBoolean(aValue);
    }
}

export function checkBoolean(value: any, retNull = false) {
    let wValue: any;
    if (retNull === false) {
        wValue = false;
    } else {
        wValue = null;
    }
    if (typeof value === 'string') {
        wValue = convertStringToBoolean(value);
    }
    if (value === false) {
        wValue = false;
    }
    if (value === true) {
        wValue = true;
    }
    return wValue;
}

export function convertStringToBoolean(aValue) {
    if (aValue.toLowerCase() === 'true' || aValue === '1') {
        return true;
    }
    if (aValue.toLowerCase() === 'false' || aValue === '0') {
        return false;
    }
    return null;
}

export function getParseDate(value) {
    return parseDate.find((item) => {
        return item.origin === value;
    });
}

export function fileConvertSize(bytes) {
    var sizes = ['o', 'Ko', 'Mo', 'Go', 'To', 'Po'];
    for (var i = 0; i < sizes.length; i++) {
        if (bytes <= 1024) {
            return bytes + ' ' + sizes[i];
        } else {
            let bytesToString = (bytes / 1024).toString();
            bytes = parseFloat(bytesToString).toFixed(2);
        }
    }
    return bytes; // + ' P';
}

export function getEditable(aItem) {
    if (aItem.Editable) {
        return checkBoolean(aItem.Editable);
    } else {
        return false;
    }
}

export function getRequired(aItem) {
    if (aItem.required) {
        return checkBoolean(aItem.required);
    } else {
        return false;
    }
}

export function getBskLabel(adata) {
    if (adata.Label !== undefined) {
        return getLabel(adata.Label, adata.Name);
    } else {
        return adata.Name;
    }
}

export function getLabel(aLabel, aName) {
    if (aLabel.length === 0) {
        aLabel = aName;
    }
    return aLabel;
}

export function setEmptyArray(aData) {
    if (!aData) {
        return (aData = []);
    }
    return aData;
}

export function getArray(adata) {
    if (adata === undefined) {
        return [];
    }
    if (!Array.isArray(adata)) {
        return [adata];
    } else return adata;
}

export function getTypeBsk(basketType: string) {
    return basketType.substring(2);
}

export function getDataFromStorage(aName) {
    try {        
        const listVar = JSON.parse(localStorage.getItem(aName));
        if (listVar) {
            return listVar;
        } else {
            return [];
        }
    } catch (error) {
        return [];
    }
}

export function verifyCustomEditorList(aCustomEditorList) {    
    let wRes = false;
    if (aCustomEditorList) {
        if (aCustomEditorList.CustomEditor) {
            if (aCustomEditorList.CustomEditor.length !== 0) {
                wRes = true;
            }
        }
    }
    return wRes;
}

export function getVariableInfo(aVarList, aName) {
    let wInfo = {
        label: aName,
        type: 'String',
    };
    try {
        if (aVarList.Variable.length !== 0) {
            for (const item of aVarList.Variable) {
                if (item.Name === aName) {
                    if (item.Label.length !== 0) {
                        wInfo.label = item.Label;
                    }
                    if (!Array.isArray(item.Type)) {
                        wInfo.type = item.Type;
                    }
                    break;
                }
            }
        }
    } catch (error) {
        console.log('getVariableInfo', error);
    }
    return wInfo;
}

export function getNoLigne(aList, aNoligne) {
    var wIndex = -1;
    for (let i = 0; i < aList.length; i++) {
        if (aList[i].noligne === aNoligne) {
            wIndex = i;
            break;
        }
    }
    return wIndex;
}

export function bskReq(aProperty, aListIndex) {
    let wBsk = 0;
    for (const item of aListIndex) {
        if (item[aProperty].substring(0, 5) === '&bsk_') {
            if (item[aProperty].substring(0, 9) === '&bsk_mail') {
                return 'mail';
            } else {
                wBsk++;    
            }
        }
    };
    if (wBsk !== 0) {
        return 'bsk';
    } else {
        return '';
    }
}

export function getMaxNoLigne(aList) {
    var wIndex = -1;
    aList.forEach((item) => {
        if (item.noligne >= wIndex) {
            wIndex = item.noligne;
        }
    });
    return wIndex;
}

export function removeInvalidFileChar(aValue) {
    return aValue.replace(/[\\/:"*?<>|]/g, '_');
}

export function changeApostrophe(aValue) {
    return aValue.replaceAll('’', "'");
}

export function setToolbar() {
    let menu = <any>document.getElementsByClassName('toolbar')[0];
    if (menu) {
        menu.style.zIndex = 0;
    }
}

export function prepareFileName(aName, aLength, aEncode) {
    let wFileName: string;
    wFileName = changeApostrophe(removeInvalidFileChar(aName.normalize('NFC')));
    wFileName = wFileName.replace(/€/g, 'eur');
    if (aEncode === true) {
        wFileName = encodeUtf8(wFileName);
    }
    wFileName = truncateFileName(wFileName, aLength);
    return wFileName;
}

export function truncateFileName(aName, aLength) {
    let wName: string;
    let wExt: string;
    wExt = getFileExt(aName);
    wName = getFileNameWithoutExt(aName);
    if (wName.length > aLength) {
        wName = wName.substring(0, aLength);
    }
    return wName + wExt;
}

export function getFileExt(aName) {
    let wFileExt = '';
    wFileExt = aName.slice((Math.max(0, aName.lastIndexOf('.')) || Infinity) + 1);
    if (wFileExt !== '') {
        wFileExt = '.' + wFileExt;
    }
    return wFileExt;
}

export function getFileNameWithoutExt(aFileName) {
    let wExt = getFileExt(aFileName.trim());
    let wFileName = aFileName.trim();
    if (wExt !== '') {
        wFileName = wFileName.slice(0, wFileName.length - wExt.length);
    }
    return wFileName;
}

export function getExportFileName(aName: string): string {
    return aName + '_export_' + new Date().getTime();
}

// public method for url encoding
export function encodeUtf8(wstring) {
    wstring = wstring.replace(/\r\n/g, '\n');
    if (isEmptyArray(wstring) === true) {
        wstring = '';
    }
    return wstring;
}


// public method for url decoding
export function decodeUtf8(utftext) {
    let wstring = utftext;
    if (isEmptyArray(utftext) === true) {
        wstring = '';
    }
    return wstring;
}

export function b64DecodeUnicode(str) {
    return decodeURIComponent(
        Array.prototype.map
            .call(atob(str), function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join('')
    );
}

export function ExecRegExp(pattern, aFlag, value) {
    const regex = new RegExp(pattern, aFlag);
    return regex.test(value);
}

export function truncateString(aMess) {
    if (aMess !== '') {
        aMess = aMess.substring(0, aMess.length - 2);
    }
    return aMess;
}

export function truncString(aItem, aLength) {
    if (aItem.length !== 0) {
        aItem = aItem.substring(0, aItem.length - aLength);
    }
    return aItem;
}

export function returnEmpty(value) {
    return value === undefined || value === null ? '' : value;
}

export function isEmpty(data: string = '') {
    return data.trim() === '';
}

export function checkLength(data: string = '', min, max) {
    if (data.length < min || data.length > max) {
        return false;
    } else {
        return true;
    }
}

export function isInArrayFromIndex(value: string = '', dataArray: Array<object>, key, index) {
    for (let i = index; i < dataArray.length; i++) {
        if (dataArray[i][key].value === value) {
            return i;
        }
    }
}

export function isInArray(value: string = '', dataArray: Array<object>, key) {
    return dataArray.find((o) => {
        return o[key].value === value;
    });
}

export function isInArrayKey(value: string = '', dataArray: Array<object>, key) {
    return dataArray.find((o) => {
        return o[key] === value;
    });
}

export function setResulProperty(aList, aName, aKey, aValue) {
    for (let index = 0; index < aList.length; index++) {
        if (aList[index].name === aName) {
            aList[index][aKey] = aValue;
            break;
        }
    }
}

export function updateResultValue(adataentete, adadadetail) {       
    let witemrequest: any = [];
    for (let i = 0; i < adadadetail.length; i++) {
        witemrequest.push({
            Name: adadadetail[i].Name,
            Label: adadadetail[i].Label,
            NumOrder: adadadetail[i].NumOrder,
            TypeOrder: adadadetail[i].TypeOrder,
            Type: adadadetail[i].Type,
            ThumbInfo: adadadetail[i].ThumbInfo
        });
    }

    const wdata = {
        entete: {
            id: adataentete.id,
            name: adataentete.name,
            desc: adataentete.desc,
            visibility: adataentete.visibility
        }
        ,
        accesslist: {
            accesslist: getListAccess(adataentete.visibility, adataentete.groupListUsed, adataentete.userListUsed)
        }
        ,
        detail: {
            itemrequest: witemrequest
        }
    };
    return wdata;
}

export function updateRequestValue(adataentete, adadadetail) {
    let witemrequest: any = [];
    for (let i = 0; i < adadadetail.length; i++) {
        witemrequest.push({
            Name: adadadetail[i].Name,
            Label: adadadetail[i].Label,
            Search: adadadetail[i].Search,
            Visible: adadadetail[i].Visible,
            Field: adadadetail[i].Field,
            Operat: adadadetail[i].Operat,
            DefaultValue: adadadetail[i].DefaultValue,
            Type: adadadetail[i].Type,
            DisplayDefault: adadadetail[i].DisplayDefault,
        });
    }

    const wdata = {
        entete: {
            id: adataentete.id,
            name: adataentete.name,
            desc: adataentete.desc,
            visibility: adataentete.visibility,
            idresult: adataentete.idresult,
            emptyField: adataentete.emptyField,
        },
        accesslist: {
            accesslist: getListAccess(adataentete.visibility, adataentete.groupListUsed, adataentete.userListUsed),
        },
        detail: {
            itemrequest: witemrequest,
        },
    };
    return wdata;
}

export function getListAccess(aVisibility, aGroupListUsed, aUserListUsed) {
    let wAccessList = [];
    if (aVisibility === 0 || aVisibility === 3) {
        wAccessList = [];
    }
    if (aVisibility === 1) {
        wAccessList = JSON.parse(JSON.stringify(aGroupListUsed));
    }
    if (aVisibility === 2) {
        wAccessList = JSON.parse(JSON.stringify(aUserListUsed));
    }
    return wAccessList;
}

export function formatCustRight(aData) {
    const wdata = {
        entete: {
            id: aData.entete.id,
            name: aData.entete.name,
            label: aData.entete.label,
            desc: aData.entete.desc,
            visibility: aData.entete.visibility,
            visibilityto: aData.entete.visibilityto,
            typeitem: aData.entete.typeitem,
        },
        accesslist: {
            accesslist: getListAccess(aData.entete.visibility, aData.entete.groupListUsed, aData.entete.userListUsed),
        },
    }   
    return wdata;
}

export function formatDelegateRight(aData) {
    const wdata = {
        entete: {
            id: aData.entete.id,
            name: aData.entete.name,
            desc: aData.entete.desc,
            visibility: aData.entete.visibility,
            visibilityto: aData.entete.visibilityTo,
        },
        accesslist: {
            accesslist: getListAccess(aData.entete.visibility, aData.entete.groupListUsed, aData.entete.userListUsed),
            accesslistto: getListAccess(aData.entete.visibilityTo, aData.entete.groupListUsedTo, aData.entete.userListUsedTo),
        },
    };
    return wdata;
}

export function formatAdminDelegate(aData) {
    const wdata = {
        entete: {
            id: aData.entete.id,
            name: aData.entete.name,
            desc: aData.entete.desc,
            rightValues: rightValues(aData.entete),
        }
    };
    return wdata;
}

export function rightValues(aData) {
    const wRightValues: { [key: string]: any } = {};
    wRightValues['mgtBsk'] = aData.mgtBsk;
    wRightValues['mgtDlgt'] = aData.mgtDlgt;
    wRightValues['mgtGed'] = aData.mgtGed;
    wRightValues['mgtGrp'] = aData.mgtGrp;
    wRightValues['mgtUser'] = aData.mgtUser;
    return JSON.stringify(wRightValues);
}

export function formatTagBsk(aData, aId, aIdList) {
    let wRequest: any;
    wRequest = new Object();
    wRequest = {
        id : aId,
        taglist: getList(aData.tagList),
        bsklist: getList(aData.basketList),
        idlist: aIdList,
    };
    return wRequest;
}

export function getList(aList) {
    let wList: any = [];
    for (let i = 0; i < aList.length; i++) {
        wList.push(aList[i]);
    }
    return wList;
}

export function getIdList(adata) {
    let wIdList = [];
    if (adata.length > 0) {
        for (let i = 0; i < adata.length; i++) {
            wIdList.push(adata[i].Id);
        }
    }
    return wIdList;        
}

export function getBskList(adata) {
    let wBasketList = [];
    if (adata.length > 0) {
        for (let i = 0; i < adata.length; i++) {
            wBasketList.push(adata[i].Bskname);
        }
    }
    return wBasketList;
}

export function getGroupListData(aData) {
    let warray = [];
    if (aData.Group) {
        if (Array.isArray(aData.Group)) {
            aData.Group.map((item) => {
                warray.push({
                    label: decodeUtf8(getBskLabel(item.Information)) + ' (' + item.Information.Name + ')',
                    value: item.Information.Name,
                });
            });
        } else {
            warray.push({
                label: decodeUtf8(getBskLabel(aData.Group.Information)) + ' (' + aData.Group.Information.Name + ')',
                value: aData.Group.Information.Name,
            });
        }
    }
    return warray;
}

export function getProfilListData(aData) {
    let warray = [];
    if (aData.ProfilGed) {
        if (Array.isArray(aData.ProfilGed)) {
            aData.ProfilGed.map((item) => {
                warray.push({
                    label: decodeUtf8(item.Information.Name)
                });
            });
        } else {
            warray.push({
                label: decodeUtf8(aData.ProfilGed.Information.Name),
            });
        }
    }
    return warray;
}

export function formatUserList(aData, aUserList) {
    let wName = '';
    aData.UserList.map((item, index) => {       
        wName = getUserName(item, 'us_firstname', 'us_lastname', 'us_login');
        aUserList.push({displayValue: wName, retCode: item.us_login});
    });
}

export function getUserListData(aData) {
    let warray = [];
    if (aData.User) {
        if (Array.isArray(aData.User)) {
            aData.User.map((item) => {
                warray.push({
                    label: getUserName(item.Information, 'FirstName', 'LastName', 'Login'),
                    value: item.Information.Login,
                });
            });
        } else {
            warray.push({
                label: getUserName(aData.User.Information, 'FirstName', 'LastName', 'Login'),
                value: aData.User.Information.Login,
            });
        }
    }
    return warray;
}

export function getUserName(aData, aKeyFName, aKeyLName, aKeyLogin) {
    let wName = '';
    wName = getField(aData[aKeyFName]) + ' ' + getField(aData[aKeyLName]);
    if (wName.trim() === '') {
        wName = aData[aKeyLogin];
    } else {
        wName += ' (' + aData[aKeyLogin] + ')';
    }
    wName = wName.trim();
    return wName;
}


export function getLastFirstName(aData) {
    let wName = '';
    wName = aData.LastName + ' ' + aData.FirstName;
    if (wName.trim() === '') {
        wName = aData.Login;
    }
    return wName.trim();
}

export function getVisibiliyValue(item) {
    if (item.visibility) {
        return getVisibiliy(item.visibility).name;
    } else {
        return getVisibiliy(0).name;
    }
}

export function getVisibiliy(avisibility) {
    return Visibility.find((visibility) => {
        return visibility.id === avisibility;
    });
}
export function loadVisibility(aTranslate) {
    let wArray = [];
    wArray.push(
        { label: aTranslate.instant('All'), value: null },
        { label: aTranslate.instant('Public'), value: 'Public' },
        { label: aTranslate.instant('Group'), value: 'Group' },
        { label: aTranslate.instant('User_1'), value: 'User' },
    )
    return wArray;
}

export function loadVisibilitySys(aTranslate) {
    let wArray = [];
    wArray = loadVisibility(aTranslate);
    wArray.push({ label: aTranslate.instant('System'), value: 'System' });
    return wArray;
}


export function getCount(aData) {
    let wRes = '';
    if (aData !== null && aData !== undefined) {
        if (aData.length !== 0) {
            wRes = '(' + aData.length + ')';
        }
    }
    return wRes;
}

// export function changeProperties(aKey, aObject, aValue){
//     aObject[aKey] = aValue;
//     return aObject;
// }

/**
 * function to sort array of objects by using object key, this sort is also able to distinguish numeric from alpha numeric value
 * @param keyname item key that will be used for sorting
 * @param items list of items to be sorted
 * @param event event captured by the filter or at least an object being one of the following: {order: 1}(for ASC) or {order: -1}(for DESC)
 */
export function sortBy(keyname: string, items: Array<any>, event: any = { order: 1 }) {
    const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
    return [
        ...items.sort((a, b) => {
            if (a[keyname] && b[keyname]) {
                let result = 0;
                if (!isNaN(a[keyname]) && isNaN(b[keyname])) {
                    result = -1;
                } else if (isNaN(a[keyname]) && !isNaN(b[keyname])) {
                    result = 1;
                } else {
                    result = collator.compare(a[keyname], b[keyname]);
                }
                if (result > 0) {
                    return result * event.order;
                }
            }
            return -1 * event.order;
        }),
    ];
}
/**
 * function to sort array of objects by using object key, to use with p-table customSort,
 * this sort is also able to distinguish numeric from alpha numeric value
 * @param event SortEvent captured
 */
export function tableSortBy(event: any) {
    const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
    event.data.sort((a, b) => {
        if (a[event.field] && b[event.field]) {
            let result = 0;
            if (!isNaN(a[event.field]) && isNaN(b[event.field])) {
                result = -1;
            } else if (isNaN(a[event.field]) && !isNaN(b[event.field])) {
                result = 1;
            } else {
                result = collator.compare(a[event.field], b[event.field]);
            }
            if (result === 0) {
                return -1;
            }
            return result * event.order;
        } else if (a[event.field]) {
            return -1 * event.order;
        } else if (b[event.field]) {
            return 1 * event.order;
        }
        return -1 * event.order;
    });
}

export function sortByReference(items: Array<any>, event) {
    return sortBy('reference', items, event);
}

export function sortByLabel(items: Array<any>, event) {
    return sortBy('_label', items, event);
}

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

// pour filtrage TurboTable
export function getItemValue(item: object, attributs: string[]) {
    let _i = 0;
    let _itemValue = item;
    while (_i < attributs.length) {
        _itemValue = _itemValue[attributs[_i]];
        _i++;
    }
    return _itemValue;
}

// pour filtrage TurboTable
export function isInArrayFilter(array: any[], value: any, attributs: string[] = null) {
    let _i = array.length;
    while (_i--) {
        if (attributs && getItemValue(array[_i], attributs) === value) {
            return true;
        } else if (array[_i] === value) {
            return true;
        }
    }
    return false;
}

// pour filtrage TurboTable
export function isInRangeFilter(event, dataTable, columnName: string, isInRangeTimeout?: any) {
    if (isInRangeTimeout) {
        clearTimeout(isInRangeTimeout);
    }

    isInRangeTimeout = setTimeout(() => {
        const _filterArray = [];
        for (let _i = event.values[0]; _i <= event.values[1]; _i++) {
            _filterArray.push(_i);
        }
        dataTable.filter(_filterArray, columnName, 'in');
    }, 250);
}

// pour filtrage TurboTable
export function containsIn(value, filter: any[]): boolean {
    if (filter === undefined || filter === null || filter.length === 0) {
        return true;
    }
    if (value === undefined || value === null) {
        return false;
    }
    for (let _i = 0; _i < filter.length; _i++) {
        if (
            filter[_i] === undefined ||
            filter[_i] === null ||
            (typeof filter[_i] === 'string' && filter[_i].trim() === '')
        ) {
            return true;
        }
        if (value === undefined || value === null) {
            return false;
        }
        const _regExp = new RegExp('\\b' + filter[_i].toLowerCase().replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') + '\\b');
        if (_regExp.test(value.toString().toLowerCase())) {
            return true;
        }
    }
    return false;
}
